module.exports = __webpack_public_path__ + "img/logo.58543d93.svg";